import { DataProvider } from 'react-admin'
import { SelfPOSAccessTicketCashlessMachineDto } from '../../dto/device/ticket-machines/selfpos-access-ticket-cashless-machine/selfpos-access-ticket-cashless-machine.dto'

const fakeFiles: SelfPOSAccessTicketCashlessMachineDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeFiles, total: fakeFiles.length }),
} as DataProvider

export default provider
